export function getSortedMarket(market, invertedMarket, isAwayAtHome) {
  if (!market || market.outcomes.length === 0) {
    return null;
  }

  const outcomes = market.outcomes.slice();
  if (outcomes.length === 1) {
    const emptyOutcome = {
      'column': 'undefined',
      'id': 0,
      'identifier': '',
      'name': '--',
      'orderNo': 'undefined',
      'originalDecimalOutcome': '--',
      'sbv': '--',
      'upDownClass': '',
      'noValue': true,
    };
    if (outcomes[0].column !== 1) {
      outcomes.unshift(emptyOutcome);
    } else {
      outcomes.push(emptyOutcome);
    }
  }

  if (invertedMarket && isAwayAtHome) {
    const reversedOutcomes = [outcomes[1], outcomes[0]];
    return {
      ...market,
      outcomes: reversedOutcomes,
    }
  }
  return {
    ...market,
    outcomes: outcomes,
  }
}

function getNestedMarket(match, marketId) {
  for (const tab of match.tabs) {
    for (const m of tab.odds) {
      if (m.marketId === marketId) {
        return m;
      }
    }
  }
}

export function getOddsAtCol(match, marketsInfo, col) {
  const marketInfo = marketsInfo[col];
  if (!marketInfo) {
    return;
  }
  const marketId = marketInfo.otid;
  if (match.isLiveMatch) {
    const liveMarket = match.odds[marketId];
    return getSortedMarket(liveMarket, marketInfo.inv, match.awayAtHome);
  }

  let prematchMarket = match.odds.filter(market => market.marketId === marketId)[0];
  if (!prematchMarket && match.tabs && match.tabs.length > 0) {
    prematchMarket = getNestedMarket(match, marketId);
  }
  return getSortedMarket(prematchMarket, marketInfo.inv, match.awayAtHome);
}

export function getMarketLabel(marketsInfo, awayAtHome, col, row) {
  if (!marketsInfo || !marketsInfo[col]) {
    return '';
  }
  const marketInfo = marketsInfo[col];
  const invertLabel = marketInfo.inv && awayAtHome;
  let lb = row;
  if (invertLabel) {
    lb = row === 1 ? 2 : 1;
  }
  return marketInfo[`sn${lb}`];
}
